import MenuItem from '@material-ui/core/MenuItem';
import styled from 'styled-components';
import { Box } from '~common/components/box.component';

export const DropdownMenuItemInner = styled(Box)`
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const DropdownMenuItem = styled(MenuItem)`
  && {
    font-weight: bold;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.3px;
  }
`;



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/view/components/ui/form/dropdown-menu-item.component.tsx